import React from "react"

export default () => (
    <svg
        width="21px"
        height="21px"
        viewBox="0 0 21 21"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
    >
        <title>Like us on Facebook</title>
        <desc>Facebook</desc>
        <g
            id="facebook-artboard"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <path
                d="M1.15910156,21 C0.518765625,21 0,20.4809063 0,19.8408984 L0,1.15910156 C0,0.518765625 0.518765625,0 1.15910156,0 L19.8410625,0 C20.4810703,0 21,0.518765625 21,1.15910156 L21,19.8408984 C21,20.4810703 20.4810703,21 19.8410625,21 L14.4896719,21 L14.4896719,12.8675859 L17.2193438,12.8675859 L17.6280234,9.69822656 L14.4896719,9.69822656 L14.4896719,7.67484375 C14.4896719,6.75724219 14.7444609,6.132 16.0602422,6.132 L17.7384375,6.13134375 L17.7384375,3.29667188 C17.4482109,3.25811719 16.4520234,3.17182031 15.2929219,3.17182031 C12.8731641,3.17182031 11.216625,4.648875 11.216625,7.36115625 L11.216625,9.69839063 L8.4800625,9.69839063 L8.4800625,12.86775 L11.2167891,12.86775 L11.2167891,21 L1.15910156,21 Z"
                id="Facebook"
                fill="#C3C8DF"
            />
        </g>
    </svg>
)
